var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 6.49995H13C13.1989 6.49995 13.3897 6.57896 13.5303 6.71962C13.671 6.86027 13.75 7.05103 13.75 7.24995V14.7499C13.75 14.9489 13.671 15.1396 13.5303 15.2803C13.3897 15.4209 13.1989 15.4999 13 15.4999H1C0.801088 15.4999 0.610322 15.4209 0.46967 15.2803C0.329018 15.1396 0.25 14.9489 0.25 14.7499V7.24995C0.25 7.05103 0.329018 6.86027 0.46967 6.71962C0.610322 6.57896 0.801088 6.49995 1 6.49995H1.75V5.74995C1.74957 4.56697 2.14869 3.41853 2.88264 2.49077C3.6166 1.56302 4.64238 0.91033 5.7937 0.638517C6.94502 0.366704 8.1544 0.491695 9.22579 0.993229C10.2972 1.49476 11.1678 2.34344 11.6965 3.4017L10.3547 4.0722C9.97712 3.31621 9.35522 2.70993 8.58987 2.35166C7.82452 1.99338 6.9606 1.90411 6.13816 2.09833C5.31572 2.29254 4.583 2.75885 4.05877 3.42165C3.53454 4.08445 3.24955 4.90489 3.25 5.74995V6.49995ZM1.75 7.99995V13.9999H12.25V7.99995H1.75ZM5.5 10.2499H8.5V11.7499H5.5V10.2499Z",
    fill: "#2E2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPassword);
export default __webpack_public_path__ + "static/media/resetPassword.fa55af8330d7b23ddd33aa33aecb6b62.svg";
export { ForwardRef as ReactComponent };